import { createStyles } from '@material-ui/core/styles';

const styles = (theme: any) => createStyles({
    splitCellContainer: {
        display: 'flex',
        alignItems: 'center'
    },
    splitCellContent: {
        flex: '5',
        color: theme.palette?.hyperLink,
        cursor: 'pointer',
        textDecoration: 'underline'
    },
    splitCellAction: {
        flex: '1',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        marginRight: '-5px',
        justifyContent: 'center'
    },
    iconWarning: {
        'color': 'RED',
        'height': '24px',
        'width': '24px',
        'verticalAlign': 'middle',
        '&:hover': {
            cursor: 'pointer'
        }
    },
});

export default styles;
